import { render, staticRenderFns } from "./WebpImage.vue?vue&type=template&id=6ce28ba8"
import script from "./WebpImage.vue?vue&type=script&lang=js"
export * from "./WebpImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports